import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arduino',
  templateUrl: './arduino.component.html',
  styleUrls: ['./arduino.component.scss'],
})
export class ArduinoComponent implements OnInit {
  modulesText = {
    text: 'Grazie a questo corso i ragazzi muoveranno i primi passi nel mondo dell’elettronica e della robotica, sviluppando al contempo soft skill come collaborazione, pensiero critico, creatività e problem solving.',
  };

  constructor() {}

  ngOnInit(): void {}
}
